var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GoBackView'),_c('WebHeaderView'),_c('ShopHeaderView'),_c('ShopProductView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }